import React from "react";
import { FileUploader } from "react-drag-drop-files";

interface IFileUpload {
    fileTypes:Array<string>;
    maxFileSize?:number;
    children: React.ReactNode;
    handleChange: (file:File) => void;
    handleTypeError: (error:string) => void;
    handleSizeError: (file:File) => void;
}

const FileUpload = (props:IFileUpload) => {
    return (
        <FileUploader
            label="Drop Here"
            types={props.fileTypes}
            maxSize={props.maxFileSize}
            children={props.children}
            handleChange={props.handleChange}
            onSizeError={props.handleSizeError}
            onTypeError={props.handleTypeError}
        />
    )
}

export default FileUpload;